import(/* webpackMode: "eager" */ "/home/oreetiene/public_html/app/(otherPages)/depozite/[depot]/page.jsx");
